/* ════════════════════════════════════════════════════════════════
   OB PRODUCT PAGE — behavior for the ob-product-* sections.
   Vanilla JS, no dependencies. Cart adds go through fetch('/cart/add.js')
   so the sitewide ob-cart-drawer snippet sees them and opens itself.
   Idempotent init: safe to re-run on shopify:section:load.
   ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function bound(el, key) {
    key = 'obpBound' + key;
    if (!el || el.dataset[key]) return true;
    el.dataset[key] = '1';
    return false;
  }

  /* ── Cart API ─────────────────────────────────────────────── */
  function cartAdd(items, cb) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    }).then(function (j) { if (cb) cb(null, j); })
      .catch(function (e) { if (cb) cb(e); });
  }

  /* ── Product state (set by ob-product-main) ───────────────── */
  var OBP = window.OBP = window.OBP || { variants: [], current: null, qty: 1 };

  function readProductData(main) {
    var tag = $('[data-obp-product-json]', main);
    if (!tag) return;
    try {
      var data = JSON.parse(tag.textContent);
      OBP.variants = data.variants || [];
      OBP.optionNames = data.options || [];
      OBP.title = data.title || '';
      OBP.savingsFormat = data.savings_format || 'dollars';
      OBP.soldOutLabel = data.sold_out_label || 'Sold Out';
      OBP.atcLabel = data.atc_label || 'Add to Cart';
      var initId = data.selected_variant_id;
      OBP.current = OBP.variants.filter(function (v) { return v.id === initId; })[0] || OBP.variants[0] || null;
    } catch (e) { /* malformed JSON: leave buy UI static */ }
  }

  function selectedOptions(main) {
    return $$('.opt[data-opt-index]', main).map(function (g) {
      var on = $('[role="radio"][aria-checked="true"]', g);
      return on ? (on.getAttribute('data-value') || '') : '';
    });
  }

  function findVariant(opts) {
    for (var i = 0; i < OBP.variants.length; i++) {
      var v = OBP.variants[i], hit = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] && v.options[j] !== opts[j]) { hit = false; break; }
      }
      if (hit) return v;
    }
    return null;
  }

  /* Disable size tiles that have no variant for the other selected options */
  function refreshAvailability(main) {
    var opts = selectedOptions(main);
    $$('.opt[data-opt-index]', main).forEach(function (g) {
      var idx = parseInt(g.dataset.optIndex, 10);
      $$('[role="radio"]', g).forEach(function (b) {
        var probe = opts.slice();
        probe[idx] = b.getAttribute('data-value');
        var v = OBP.variants.filter(function (x) {
          for (var j = 0; j < probe.length; j++) if (probe[j] && x.options[j] !== probe[j]) return false;
          return true;
        })[0];
        var out = !v || !v.available;
        if (b.classList.contains('sw-size')) b.disabled = out;
        b.setAttribute('data-unavailable', out ? '1' : '0');
      });
    });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function applyVariant(main, v) {
    OBP.current = v;
    var priceEl = $('[data-obp-price]', main),
        wasEl = $('[data-obp-was]', main),
        saveEl = $('[data-obp-save]', main),
        flagEl = $('[data-obp-flag]', main);
    var onSale = v && v.compare_at_price && v.compare_at_price > v.price;
    if (priceEl && v) priceEl.textContent = money(v.price);
    if (wasEl) { wasEl.textContent = onSale ? money(v.compare_at_price) : ''; wasEl.classList.toggle('obp-hide', !onSale); }
    if (saveEl) {
      if (onSale) {
        saveEl.textContent = OBP.savingsFormat === 'percent'
          ? 'Save ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'
          : 'Save ' + money(v.compare_at_price - v.price);
      }
      saveEl.classList.toggle('obp-hide', !onSale);
    }
    if (flagEl) flagEl.classList.toggle('obp-hide', !onSale);

    $$('[data-obp-atc]', main.parentNode ? document : main).forEach(function (b) {
      var out = !v || !v.available;
      b.disabled = out;
      b.textContent = out ? OBP.soldOutLabel : OBP.atcLabel;
    });

    if (v) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    if (v && v.featured_media_id) {
      var t = $('.a-thumb[data-media-id="' + v.featured_media_id + '"]', main);
      if (t) railSelect(main, t);
    }

    syncSticky(main);
  }

  function syncSticky(main) {
    var bar = $('.stickybar');
    if (!bar || !OBP.current) return;
    var mt = $('.sb-mt', bar);
    if (mt) {
      var bits = OBP.current.options.filter(function (o) { return o && o !== 'Default Title'; });
      bits.push(money(OBP.current.price));
      mt.textContent = bits.join(' · ');
    }
    var btn = $('[data-obp-atc]', bar);
    if (btn) { btn.disabled = !OBP.current.available; btn.textContent = OBP.current.available ? OBP.atcLabel : OBP.soldOutLabel; }
  }

  /* ── Gallery (Direction A rail) ───────────────────────────── */
  function railSelect(main, t) {
    var rail = $('.a-rail', main), img = $('[data-obp-main-img]', main);
    if (!rail || !img || !t) return;
    $$('.a-thumb', rail).forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
    img.src = t.dataset.src;
    img.alt = (t.querySelector('img') || {}).alt || '';
  }

  function initGallery(main) {
    var rail = $('.a-rail', main);
    if (rail && !bound(rail, 'Rail')) {
      rail.addEventListener('click', function (e) {
        var t = e.target.closest('.a-thumb');
        if (t) railSelect(main, t);
      });
      rail.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var thumbs = $$('.a-thumb', rail);
        var cur = thumbs.indexOf($('.a-thumb[aria-current="true"]', rail));
        var next = (cur + (e.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
        thumbs[next].focus(); railSelect(main, thumbs[next]);
        e.preventDefault();
      });
    }
  }

  /* ── Full-size popup ──────────────────────────────────────── */
  function initLightbox(main) {
    var lb = $('.lb', main);
    if (!lb || bound(lb, 'Lb')) return;
    var lbImg = $('.lb-img', lb), lbCap = $('.lb-cap', lb), lbRail = $('.lb-rail', lb), lbI = 0;
    var shots = $$('[data-lb-shot]', main).map(function (el) {
      return { src: el.dataset.full, alt: el.dataset.alt || '', thumb: el.dataset.thumb };
    });
    if (!shots.length) return;
    lbRail.innerHTML = shots.map(function (s, i) {
      return '<button type="button" data-lb-go="' + i + '" aria-current="false"><img src="' + s.thumb + '" alt="" /></button>';
    }).join('');
    function show(i) {
      lbI = (i + shots.length) % shots.length;
      lbImg.classList.remove('is-zoom');
      lbImg.src = shots[lbI].src; lbImg.alt = shots[lbI].alt;
      if (lbCap) lbCap.textContent = shots[lbI].alt;
      $$('[data-lb-go]', lbRail).forEach(function (b) { b.setAttribute('aria-current', +b.dataset.lbGo === lbI ? 'true' : 'false'); });
    }
    function open(at) {
      var idx;
      if (typeof at === 'number' && !isNaN(at)) {
        idx = at;
      } else {
        var cur = $('.a-thumb[aria-current="true"]', main);
        idx = cur ? $$('.a-thumb', main).indexOf(cur) : 0;
      }
      show(idx < 0 ? 0 : idx);
      lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    $$('[data-open-lb]', main).forEach(function (b) {
      if (!bound(b, 'LbBtn')) b.addEventListener('click', function () {
        open(b.dataset.lbIndex === undefined ? undefined : parseInt(b.dataset.lbIndex, 10));
      });
    });
    $$('[data-open-lb-surface]', main).forEach(function (s) {
      if (!bound(s, 'LbSurface')) s.addEventListener('click', function (e) { if (!e.target.closest('[data-open-lb]')) open(); });
    });
    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-lb-close]')) return close();
      var step = e.target.closest('[data-lb-step]'); if (step) return show(lbI + +step.dataset.lbStep);
      var go = e.target.closest('[data-lb-go]'); if (go) return show(+go.dataset.lbGo);
    });
    function pan(e) {
      var r = lbImg.getBoundingClientRect();
      lbImg.style.setProperty('--lx', ((e.clientX - r.left) / r.width * 100).toFixed(2) + '%');
      lbImg.style.setProperty('--ly', ((e.clientY - r.top) / r.height * 100).toFixed(2) + '%');
    }
    lbImg.addEventListener('click', function (e) { pan(e); lbImg.classList.toggle('is-zoom'); });
    lbImg.addEventListener('pointermove', function (e) { if (lbImg.classList.contains('is-zoom')) pan(e); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(lbI - 1);
      if (e.key === 'ArrowRight') show(lbI + 1);
    });
  }

  /* ── Buy area ─────────────────────────────────────────────── */
  function initBuy(main) {
    readProductData(main);

    $$('.opt[data-opt-index]', main).forEach(function (g) {
      if (bound(g, 'Opt')) return;
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[role="radio"]');
        if (!b || b.disabled) return;
        $$('[role="radio"]', g).forEach(function (r) { r.setAttribute('aria-checked', r === b ? 'true' : 'false'); });
        var head = g.querySelector('.opt-label .val');
        if (head) head.textContent = '— ' + (b.getAttribute('data-value') || b.textContent.trim());
        refreshAvailability(main);
        applyVariant(main, findVariant(selectedOptions(main)));
      });
    });

    $$('.qty', main).forEach(function (q) {
      if (bound(q, 'Qty')) return;
      var input = q.querySelector('input');
      q.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-q]'); if (!b) return;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.q, 10));
        OBP.qty = parseInt(input.value, 10);
      });
      input.addEventListener('change', function () {
        input.value = Math.max(1, parseInt(input.value, 10) || 1);
        OBP.qty = parseInt(input.value, 10);
      });
    });

    $$('[data-obp-atc]', document).forEach(function (b) {
      if (bound(b, 'Atc')) return;
      b.addEventListener('click', function () {
        if (!OBP.current || !OBP.current.available) return;
        b.disabled = true;
        cartAdd([{ id: OBP.current.id, quantity: OBP.qty || 1 }], function (err) {
          b.disabled = false;
          if (err) alert((err && err.description) || 'Could not add to cart.');
        });
      });
    });

    $$('[data-obp-buy-now]', main).forEach(function (b) {
      if (bound(b, 'Bin')) return;
      b.addEventListener('click', function () {
        if (!OBP.current || !OBP.current.available) return;
        b.disabled = true;
        cartAdd([{ id: OBP.current.id, quantity: OBP.qty || 1 }], function (err) {
          b.disabled = false;
          if (err) { alert((err && err.description) || 'Could not add to cart.'); return; }
          window.location.href = '/checkout';
        });
      });
    });

    if (OBP.current) { refreshAvailability(main); applyVariant(main, OBP.current); }
  }

  /* ── Sticky ATC bar (mobile) ──────────────────────────────── */
  function initSticky(main) {
    var bar = $('.stickybar');
    if (!bar || bound(bar, 'Bar')) return;
    var live = $('[data-obp-atc]', main);
    if (!live || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      bar.classList.toggle('is-up', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(live);
    syncSticky(main);
  }

  /* ── Size guide drawer ────────────────────────────────────── */
  function initSizeGuide() {
    var drawer = $('.sgd');
    $$('[data-open-size]').forEach(function (l) {
      if (bound(l, 'Sg')) return;
      l.addEventListener('click', function () {
        if (drawer) {
          drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        } else {
          var el = document.getElementById('sizeGuide');
          if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 130, behavior: 'smooth' });
        }
      });
    });
    if (drawer && !bound(drawer, 'SgClose')) {
      function close() {
        drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
      drawer.addEventListener('click', function (e) { if (e.target.closest('[data-sgd-close]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
    }
  }

  /* ── Unit toggles (inline table + drawer copy) ────────────── */
  function initUnits() {
    $$('.unit-toggle').forEach(function (ut) {
      if (bound(ut, 'Unit')) return;
      ut.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-unit]'); if (!b) return;
        $$('button', ut).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        var scope = ut.closest('[data-size-guide]') || document;
        $$('.sizes-tbl td', scope).forEach(function (td) { td.textContent = td.dataset[b.dataset.unit] || td.textContent; });
      });
    });
  }

  /* ── Accordions ───────────────────────────────────────────── */
  function initAccordions() {
    if (bound(document.documentElement, 'Acc')) return;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.acc-btn'); if (!b) return;
      var item = b.parentElement, open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ── In-page nav: build from sections present, then scrollspy ─ */
  function initSecnav() {
    var snav = $('.secnav');
    if (!snav || bound(snav, 'Nav')) return;
    var inWrap = $('.secnav-in', snav);
    var targets = $$('[data-obp-nav]').filter(function (s) { return s.id; });
    if (!targets.length) { snav.classList.add('obp-hide'); return; }
    inWrap.innerHTML = targets.map(function (s, i) {
      return '<a href="#' + s.id + '"' + (i === 0 ? ' class="is-on"' : '') + '>' + s.dataset.obpNav + '</a>';
    }).join('');
    var links = $$('a', inWrap);
    inWrap.addEventListener('click', function (e) {
      var a = e.target.closest('a'); if (!a) return;
      var t = $(a.getAttribute('href')); if (!t) return;
      e.preventDefault();
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 140, behavior: 'smooth' });
    });
    window.addEventListener('scroll', function () {
      var y = window.scrollY + 180, cur = null;
      links.forEach(function (a) {
        var t = $(a.getAttribute('href'));
        if (t && t.getBoundingClientRect().top + window.scrollY <= y) cur = a;
      });
      links.forEach(function (a) { a.classList.toggle('is-on', a === cur); });
    }, { passive: true });
  }

  /* ── Complete the kit ─────────────────────────────────────── */
  function initKit() {
    $$('[data-obp-kit]').forEach(function (sec) {
      if (bound(sec, 'Kit')) return;
      var grid = $('.kit-grid', sec), rows = $('[data-kt-rows]', sec), tot = $('[data-kt-total]', sec);
      var baseName = sec.dataset.kitBaseName || 'This product';
      function basePrice() { return OBP.current ? OBP.current.price : parseInt(sec.dataset.kitBasePrice || '0', 10); }
      function sync() {
        var sum = basePrice();
        var html = '<div class="kt-row"><span>' + baseName + '</span><span>' + money(basePrice()) + '</span></div>';
        $$('.addon', grid).forEach(function (a) {
          var on = a.getAttribute('aria-pressed') === 'true', p = parseInt(a.dataset.price, 10);
          if (on) sum += p;
          html += '<div class="kt-row' + (on ? '' : ' is-off') + '"><span>' + a.dataset.nm + '</span><span>' + money(p) + '</span></div>';
        });
        if (rows) rows.innerHTML = html;
        if (tot) tot.textContent = money(sum);
      }
      grid.addEventListener('click', function (e) {
        var a = e.target.closest('.addon'); if (!a) return;
        a.setAttribute('aria-pressed', a.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        sync();
      });
      var addBtn = $('[data-obp-kit-add]', sec);
      if (addBtn) addBtn.addEventListener('click', function () {
        var items = [];
        if (OBP.current && OBP.current.available) items.push({ id: OBP.current.id, quantity: 1 });
        else if (sec.dataset.kitBaseVariant) items.push({ id: parseInt(sec.dataset.kitBaseVariant, 10), quantity: 1 });
        $$('.addon[aria-pressed="true"]', grid).forEach(function (a) {
          items.push({ id: parseInt(a.dataset.vid, 10), quantity: 1 });
        });
        if (!items.length) return;
        addBtn.disabled = true;
        cartAdd(items, function (err) {
          addBtn.disabled = false;
          if (err) alert((err && err.description) || 'Could not add the kit to the cart.');
        });
      });
      sync();
    });
  }

  /* ── Media band ───────────────────────────────────────────── */
  function initMedia() {
    $$('[data-obp-media]').forEach(function (fig) {
      if (bound(fig, 'Media')) return;
      var play = $('.media-play', fig), video = $('video', fig), poster = $('img', fig);
      if (!play || !video) return;
      play.addEventListener('click', function () {
        fig.classList.add('is-playing');
        if (poster) poster.classList.add('obp-hide');
        play.classList.add('obp-hide');
        var cap = $('.media-cap', fig); if (cap) cap.classList.add('obp-hide');
        video.classList.remove('obp-hide');
        video.play();
      });
    });
  }

  /* ── Related products via the recommendations API ─────────── */
  function initRelated() {
    $$('[data-obp-related]').forEach(function (sec) {
      if (bound(sec, 'Rel')) return;
      var url = sec.dataset.recUrl;
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('.rel-grid');
        var mine = $('.rel-grid', sec);
        if (fresh && fresh.children.length && mine) mine.innerHTML = fresh.innerHTML;
      }).catch(function () { /* keep the Liquid fallback grid */ });
    });
  }

  /* ── Boot ─────────────────────────────────────────────────── */
  function init() {
    var main = $('[data-obp-main]');
    if (main) {
      initBuy(main);
      initGallery(main);
      initLightbox(main);
      initSticky(main);
    }
    initSizeGuide();
    initUnits();
    initAccordions();
    initSecnav();
    initKit();
    initMedia();
    initRelated();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();
